import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { motion } from 'framer-motion';
import AnimatedPage from '../components/AnimatedPage';
import ReusableModal from '../components/ReusableModal';
import { 
  calcModals, 
  showModalContent, 
  hideModalContent 
} from '../helpers/functions';
import { calcInteractions } from '../helpers/functions';
import BgImage from '../assets/MWC-Services_Start.jpg';
import VideoBgLoop from '../assets/MWC-Services_Start-Loop.mp4';
import ModalOneSrc from '../assets/home/MWC_Global-Scale-and-Skills.jpg';

const fadeIn = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 1,
    }
  },
  exit: {
    opacity: 0,
  }
}

export default function Home() {
  const [interactionsWidth, setInteractionsWidth] = useState('0px');
  const [interactionsHeight, setInteractionsHeight] = useState('0px');
  const [show1, setShow1] = useState(false);

  useEffect(() => {
    let sixteenNineAspect = 16 / 9;
    let viewportHeight = window.innerHeight;
    let viewportWidth = window.innerWidth;
    let widthIfConstarainedByHeight = viewportHeight * sixteenNineAspect;
    let heightIfConstarainedByWidth = viewportWidth / sixteenNineAspect;
    
    // calculate interactions size on load
    if (widthIfConstarainedByHeight <= viewportWidth) {
      setInteractionsWidth(widthIfConstarainedByHeight + "px");
      setInteractionsHeight(viewportHeight + "px");
    } else {
      setInteractionsWidth(viewportWidth + "px");
      setInteractionsHeight(heightIfConstarainedByWidth + "px");
    }

    // functions
    const resizeFunctions = () => {
      calcInteractions();
      calcModals();
    };

    // listeners
    window.addEventListener('resize', resizeFunctions);
  }, []);

  return (
    <AnimatedPage>
      <main className="d-flex flex-grow-1 flex-column justify-content-center align-items-center bg-black overflow-hidden">
        <div className="ratio ratio-16x9 mh-100vh">
          <img src={BgImage} style={{objectFit: 'contain'}} alt="Home img" />
          <motion.video 
            variants={fadeIn}
            initial="initial"
            animate="animate"
            exit="exit"
            src={VideoBgLoop} 
            type="video/mp4" 
            className="w-100" 
            loop 
            autoPlay 
            muted
          />
          <div className="interactions overflow-hidden" style={{width: interactionsWidth, height: interactionsHeight}}>
            <Link to="/otel" role="button">
              <div className="position-absolute nav-otel" style={{width: 15 + '%', height: 26.6667 + '%', borderRadius: 50+ '%', top: 67.5 + '%', left: 10.7 + '%'}}></div>
            </Link>
            <Link to="/factory" role="button">
              <div className="position-absolute nav-factory" style={{width: 15 + '%', height: 26.6667 + '%', borderRadius: 50+ '%', top: 11.5 + '%', left: 10.7 + '%'}}></div>
            </Link>
            <Link to="/deployment" role="button">
              <div className="position-absolute nav-deployment" style={{width: 15 + '%', height: 26.6667 + '%', borderRadius: 50+ '%', top: 20.5 + '%', left: 45.2 + '%'}}></div>
            </Link>
            <Link to="/managed-services" role="button">
              <div className="position-absolute nav-managed-services" style={{width: 15 + '%', height: 26.6667 + '%', borderRadius: 50+ '%', top: 26.5 + '%', left: 29.6 + '%'}}></div>
            </Link>
            <Link to="/support" role="button">
              <div className="position-absolute nav-support" style={{width: 15 + '%', height: 26.6667 + '%', borderRadius: 50+ '%', top: 16.5 + '%', left: 78.1 + '%'}}></div>
            </Link>
            <Link to="/private-5g" role="button">
              <div className="position-absolute nav-private-5g" style={{width: 15 + '%', height: 26.6667 + '%', borderRadius: 50+ '%', top: 54.5 + '%', left: 64.5 + '%'}}></div>
            </Link>

            <button onClick={() => setShow1(true)}>
            <div className="position-absolute modal-global" style={{width: 9.7 + '%', height: 14 + '%', bottom: 0 + '%', right: 0 + '%'}}></div>
            </button>
            <ReusableModal
              show={show1}
              handleClose={() => setShow1(false)}
              handleShow={() => setShow1(true)}
              size="xl"
              onEnter={calcModals}
              onEntered={showModalContent}
              onExit={hideModalContent}
            >
              <img 
                src={ModalOneSrc} 
                alt="Global Scale and Skills" 
                className="w-100"
              />
            </ReusableModal>
          </div>
        </div>
      </main>
    </AnimatedPage>
  )
}
